import { render, staticRenderFns } from "./GroupDataFile.vue?vue&type=template&id=e6e73260&scoped=true"
import script from "./GroupDataFile.vue?vue&type=script&lang=js"
export * from "./GroupDataFile.vue?vue&type=script&lang=js"
import style0 from "./GroupDataFile.vue?vue&type=style&index=0&id=e6e73260&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e73260",
  null
  
)

export default component.exports